import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-o-ring-design-technical-index',
    templateUrl: './o-ring-design-technical-index.component.html',
    styleUrls: [
        './o-ring-design-technical-index.component.scss',
        '../responsive.scss',
    ],
    standalone: false
})
export class ORingDesignTechnicalIndexComponent implements OnInit {
  constructor(
    private meta: Meta,
  ) {
    this.meta.updateTag({name: "search-title", class: "swiftype", content: "Design & Technical Index", "data-type": "string"});
  }

  ngOnInit() {
  }

}
